export default "__VITE_ASSET__dcd768e4__"